import {
  axiosGetWithCookies,
  axiosPatchWithCookies,
  axiosPostWithCookies,
} from './helper';
import { startOfDay, endOfDay } from 'utils/time';

const PATH = '/regions/sites/visits';

export const getVisitList = ({
  search,
  businessClientId,
  site,
  visitor,
  destination,
  purpose,
  showCurrentVisitsOnly = true,
  from,
  type,
  dateTo,
  dateFrom,
  timezone,
}) => {
  let query = `${PATH}?showCurrentVisitsOnly=${showCurrentVisitsOnly}&limit=50`;
  if (businessClientId) query += `&businessClientId=${businessClientId}`;
  if (site) query += site.id ? `&siteId=${site.id}` : `&siteId=${site}`;
  if (visitor) query += `&visitor=${visitor.name}`;
  if (from) query += `&from=${from}`;
  if (type) query += `&type=${type.typeName}`;
  if (destination) query += `&destination=${destination.id}`;
  if (purpose) query += `&purpose=${purpose.name}`;
  if (dateTo)
    query += `&toDate=${endOfDay({
      date: dateTo,
      timezone,
    })}`;
  if (dateFrom)
    query += `&fromDate=${startOfDay({
      date: dateFrom,
      timezone,
    })}`;

  if (search) query += `&search=${search}`;

  return axiosGetWithCookies(query);
};

export const getVisitDetail = ({ id }) => {
  const query = `${PATH}/${id}`;
  return axiosGetWithCookies(query);
};

export const logoutVisitor = ({
  id,
  visitor,
  egressTime,
  accessTime,
  siteId,
  siteName,
  passId,
}) => {
  return axiosPatchWithCookies(`${PATH}/${id}/sign-out`, {
    data: { id, visitor, egressTime, accessTime, siteId, siteName, passId },
  });
};

export const fetchVisitListPdf = ({
  search,
  businessClientId,
  site,
  visitor,
  destination,
  purpose,
  showCurrentVisitsOnly = true,
  from,
  type,
  dateTo,
  dateFrom,
  timezone,
  language,
}) => {
  let query = `${PATH}/pdf?showCurrentVisitsOnly=${showCurrentVisitsOnly}`;
  if (businessClientId) query += `&businessClientId=${businessClientId}`;
  if (site) query += site.id ? `&siteId=${site.id}` : `&siteId=${site}`;
  if (visitor) query += `&visitor=${visitor.name}`;
  if (from) query += `&from=${from}`;
  if (type) query += `&type=${type.typeName}`;
  if (destination) query += `&destination=${destination.id}`;
  if (purpose) query += `&purpose=${purpose.name}`;
  if (dateTo)
    query += `&toDate=${endOfDay({
      date: dateTo,
      timezone,
    })}`;
  if (dateFrom)
    query += `&fromDate=${startOfDay({
      date: dateFrom,
      timezone,
    })}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (search) query += `&search=${search}`;
  if (language) query += `&language=${language}`;

  if (search) query += `&search=${search}`;

  return axiosGetWithCookies(query);
};

export const fetchVisitDetailsPdf = ({ id, timezone, language }) => {
  let query = `${PATH}/${id}/pdf`;

  if (timezone) query += `?timezone=${timezone}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};
//visitor types

const VISITOR_TYPE_PATH = '/regions/visitor-types';
export const fetchVisitorTypes = ({ archived, search }) => {
  let query = VISITOR_TYPE_PATH;
  if (archived) {
    query += `?includeArchived=${archived}`;
    if (search) query += `&search=${search}`;
  } else if (search) query += `?search=${search}`;
  return axiosGetWithCookies(query);
};
export const createVisitorTypes = ({ typeName }) => {
  return axiosPostWithCookies(VISITOR_TYPE_PATH, {
    data: { typeName },
  });
};
export const updateVisitorTypes = ({ id, typeName, archived }) => {
  return axiosPatchWithCookies(VISITOR_TYPE_PATH, {
    data: { id, typeName, archived },
  });
};
export const getPreviousVisitorList = ({
  site,
  search,
  from = 0,
  limit = 50,
}) => {
  let query = `${PATH}/previous?from=${from}&limit=${limit}`;
  if (site) query += site.id ? `&siteId=${site.id}` : `&siteId=${site}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};
export const getPurposeList = ({ site, search, from = 0, limit = 10 }) => {
  let query = `/regions/sites/purposes?from=${from}&limit=${limit}`;
  if (site) query += site.id ? `&siteId=${site.id}` : `&siteId=${site}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};
